import { Fragment, useEffect } from "react";
import { t, use } from "i18next";

import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/pro-regular-svg-icons";
import { ButtonSecondary } from "../atoms/ButtonSecondary";
import { TableLoader } from "../molecules/TableLoader";
import EllipsesMenu from "../molecules/EllipsesMenu";
import ColumnText from "../molecules/ColumnText";
import { Select } from "./Select";
import { Empty } from "./Empty";

// Utils
import { formatDateTimeWithTimeObject } from "@/shared/utils/formatedDate";

type AccessProps = {
  id: string;
  user: {
    name: string;
    email: string;
    dni: string;
    remainder_pending: boolean;
  };
  date: string;
  state: string;
  description: string;
  installation: {
    name: string;
  };
  torniquete: string;
  lado: string;
  sentido: string;
  type: number;
  created_at: string;
  side: string;
  lathe: {
    device: string;
  }
  action: string;
  computer:{
    description: string;
  }
};

type optionProps = {
  id: number;
  name: string;
};

type optionEllipse = {
  name: string;
  functionMenu: () => void;
};

export type TableListMaintenanceProps = {
  title: string;
  access: AccessProps[];
  titleSelectCompany: string;
  selectedCompany: optionProps;
  setSelectedCompany: (options: optionProps) => void;
  optionsCompany: optionProps[];
  titleSelectBranchs: string;
  selectedBranchs: optionProps;
  setSelectedBranchs: (options: optionProps) => void;
  optionsBranchs: optionProps[];
  optionsMenuEllipses: optionEllipse[];
  onClickFilter?: () => void;
  onClickPermitir?: () => void;
  onClickRegistrar?: () => void;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchQuery: string;
  page: number;
  isLoading?: boolean;
};

const TableListAccess: React.FC<TableListMaintenanceProps> = ({
  title,
  access,
  titleSelectCompany,
  selectedCompany,
  setSelectedCompany,
  optionsCompany,
  titleSelectBranchs,
  selectedBranchs,
  setSelectedBranchs,
  optionsBranchs,
  optionsMenuEllipses,
  onClickFilter,
  onClickPermitir,
  onClickRegistrar,
  onSearchChange,
  searchQuery,
  page,
  isLoading,
}) => {
  const itemsPerPage = 10;
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedAccess = access.slice(startIndex, endIndex);

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="flex-grow">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {title}
          </h1>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0"></div>
      </div>

      {/* Divider debajo del texto */}
      <div className="border-b border-gray-300 my-3"></div>
      <div className="flex flex-col lg:flex-row lg:gap-x-2 bottom">
        <div className="flex flex-col flex-1 gap-4 lg:gap-2 lg:flex-row lg:items-start">
          <div className="col-span-full">
            <InputWithCornerHint
              label={t("general.search")}
              type="text"
              value={searchQuery}
              onChange={onSearchChange}
              placeholder={t("share.views.name_email_dni")}
            />
          </div>
          <div className="col-span-full">
            <Select
              name="titleCompany"
              tittle={titleSelectCompany}
              selected={selectedCompany}
              setSelected={() => setSelectedCompany}
              options={optionsCompany}
            />
          </div>
          <div className="col-span-full">
            <Select
              name="titleBranchs"
              tittle={titleSelectBranchs}
              selected={selectedBranchs}
              setSelected={(branch) => {
                setSelectedBranchs(branch);
              }}
              options={optionsBranchs}
            />
          </div>
          <div className="col-span-full">
            <button
              onClick={onClickFilter}
              type="button"
              className=" lg:mt-5 p-2 text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">View KPIs</span>
              <FontAwesomeIcon
                icon={faFilter}
                aria-hidden="true"
                className="h-6 w-6"
              />
            </button>
          </div>
        </div>
        <div className="flex flex-col lg:flex-row lg:items-center gap-3 gap-x-2 lg:gap-x-2 pt-6 lg:pt-0 lg:self-end mb-1">
          <ButtonSecondary
            text={t("share.views.permitir_acceso")}
            onClick={onClickPermitir}
            size="large"
          />
          <ButtonSecondary
            text={t("share.views.registrar_acceso")}
            onClick={onClickRegistrar}
            size="large"
          />
          <EllipsesMenu name="options" options={optionsMenuEllipses} />
        </div>
      </div>

      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full px-3 py-2 align-middle sm:px-6 lg:px-8">

            {isLoading ? (
              <TableLoader columns={9} />
            ) : (
              paginatedAccess.length === 0 ? (
                <Empty texto={t("maintenance.views.no_task")} />
              ) : (
                <Fragment>
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                        >
                          {t("share.views.id")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("share.views.user")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-32"
                        >
                          {t("share.views.dateEntry")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-32"
                        >
                          {t("share.views.state")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-44"
                        >
                          {t("share.views.description")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("share.views.instalation")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("share.views.torniquete")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("share.views.lado")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("share.views.sentido")}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {paginatedAccess.map((access) => (
                        <tr key={access.id}>
                          <ColumnText title={access.id} />
                          <ColumnText title={
                            access.user ? (
                              access.user.name
                            ) : <></>
                          } />
                          <td className="px-3 py-3.5 text-left text-sm text-gray-500 w-32">
                            <div>
                              <span 
                                className={`${access.type === 1 ? "text-orange-300" : ""}`}
                              >
                                {formatDateTimeWithTimeObject(access.created_at).date}
                              </span>
                              <br />
                              <span 
                                className={`${access.type === 1 ? "text-orange-300" : ""}`}
                              >
                                {formatDateTimeWithTimeObject(access.created_at).time}
                              </span>
                            </div>
                          </td>
                          <td className="px-3 py-3.5 text-left text-sm text-gray-500 w-32">
                            {
                              access.type == 0 ? (
                                <span className="text-red-500">{t("access.views.authorized_denied")}</span>
                              ) : (
                                access.type == 1 ? (
                                  <span>{t("access.views.authorized_access")}</span>
                                ) : (
                                  access.type == 2 ? (
                                    <span className="text-orange-300">{t("access.views.authorized_access")}</span>
                                  ) : <></>
                                )
                              )
                            }
                          </td>
                          <td className="px-3 py-3.5 text-left text-sm text-gray-500 w-44">
                            {access.type == 2 ? (
                              <span className="text-orange-300">{
                                access.user ? (
                                  access.user.name
                                ) : <></>
                              }</span>
                            ) : <></>}
  
                            {t(access.description)}
  
                            { (access.user != null && access.user.remainder_pending) ? (
                              <span className="text-orange-300">El usuario tiene un remanente pendiente</span>
                            ) : <></>}
                          </td>
                          <td className="px-3 py-3.5 text-left text-sm text-gray-500 w-32">
                            <span 
                              className={`${access.type === 2 ? "text-orange-300" : ""}`}
                            >
                              {access.installation ? (
                                access.installation.name
                              ): <></>}
                              {" - "}
                              {access.computer ? (
                                  access.computer.description
                              ): <></>}
                            </span>
                          </td>
                          <td className="px-3 py-3.5 text-left text-sm text-gray-500 w-32">
                            <span 
                              className={`${access.type === 2 ? "text-orange-300" : ""}`}
                            >
                              {access.lathe ? (
                                access.lathe.device
                              ): <></>}
                            </span>
                          </td>
                          <ColumnText title={
                            <span 
                              className={`${access.type === 2 ? "text-orange-300" : ""}`}
                            >
                              {access.side === 'right' ? 'Derecha' : ''}
                              {access.side === 'left' ? 'Izquierda' : ''}
                            </span>
                          }/>
                          <ColumnText title={
                            <span 
                              className={`${access.type === 2 ? "text-orange-300" : ""}`}
                            >
                              {access.action === 'input' ? 'Entrada' : ''}
                              {access.action === 'output' ? 'Salida' : ''}
                            </span>
                          }/>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Fragment>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListAccess;
